<template>
  <div class="ranking-container">
    <div :id="`ranking-accordion-${id}`" class="accordion">
      <div class="accordion-item">
        <h2 class="accordion-header" :class="{ 'accordion-header--disabled': isLoading }">
          <button
            class="accordion-button collapsed fw-bold"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="`#ranking-collapse-${id}`"
            aria-expanded="false"
            :aria-controls="`ranking-collapse-${id}`"
          >
            <span>📈 Classement Actualisé</span>
          </button>
        </h2>
        <div
          :id="`ranking-collapse-${id}`"
          class="accordion-collapse collapse"
          :data-bs-parent="`#ranking-accordion-${id}`"
        >
          <div class="accordion-body">
            <p class="ranking-explanation mb-3 text-muted">
              Ce classement est actualisé en temps réel avec les résultats simulés de tous les matchs de la ligue (remplacements, bonus appliqués et buts MPG inclus).
            </p>
            <div v-if="ranking && ranking.standings && ranking.standings.length" class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">
                      #
                    </th>
                    <th scope="col">
                      Équipe
                    </th>
                    <th scope="col" class="text-center">
                      J
                    </th>
                    <th scope="col" class="text-center">
                      Pts
                    </th>
                    <th scope="col" class="text-center">
                      Diff
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="team in ranking.standings" :key="team.teamId">
                    <th scope="row">
                      {{ team.rank }}
                    </th>
                    <td class="text-start">
                      <div class="fw-bold text-truncate">
                        {{ ranking.teamsNames[team.teamId] || team.teamId }}
                      </div>
                    </td>
                    <td class="text-center">
                      {{ team.played }}
                    </td>
                    <td class="text-center fw-bold">
                      {{ team.points }}
                      <span v-if="team.pointsGained > 0" class="text-primary small ms-1">
                        (+{{ team.pointsGained }})
                      </span>
                    </td>
                    <td class="text-center">
                      <span :class="team.difference > 0 ? 'text-success' : team.difference < 0 ? 'text-danger' : ''">
                        {{ team.difference > 0 ? '+' : '' }}{{ team.difference }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="alert alert-info mb-0">
              Aucun classement disponible pour cette division.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  ranking: {
    type: Object,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.ranking-container {
  background: white;
  overflow: hidden;

  .accordion-body {
    padding: 0;
  }

  .accordion-header {
    &--disabled {
      pointer-events: none;

      .accordion-button {
        background: linear-gradient(
          90deg,
          #f0f0f0 25%,
          #e0e0e0 50%,
          #f0f0f0 75%
        );
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
      }
    }
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
}

.accordion-button:not(.collapsed) {
  background-color: #e7f1ff;
  color: #0c63e7;
}

.table {
  font-size: 0.9rem;

  th, td {
    vertical-align: middle;
  }
}

.ranking-explanation {
  padding: .7em .5em;
  font-size: 0.8rem;
  line-height: 1.4;
}
</style>